<div class="monitoring">
  <div class="monitoring__banner">
    <div class="monitoring__metrics">
      <h2>Activity rate</h2>
      <div class="monitoring__rate">{{ activitiesPerSecond | number: '1.1-1' }} /s</div>
      <div class="monitoring__rate-graph">
        <ngx-charts-line-chart
          [results]="activityChartSeries"
          [autoScale]="true"
          [animations]="true"
          [legend]="false"
          [showXAxisLabel]="false"
          [showYAxisLabel]="false"
          [timeline]="false"
        >
        </ngx-charts-line-chart>
      </div>
    </div>

    <div class="monitoring__gauges">
      <div class="vu-gauge" *ngFor="let t of ['GET', 'PUT', 'POST', 'DELETE']">
        <div class="vu-gauge__label">{{ t }}</div>
        <div class="vu-gauge__meter">
          <div class="vu-gauge__needle" [style.transform]="'rotate(' + getGaugeAngle(perTypeActivitiesPerSecond[t] || 0) + 'deg)'"></div>
          <div class="vu-gauge__scale"></div>
        </div>
        <div class="vu-gauge__value">{{ perTypeActivitiesPerSecond[t] || 0 | number: '1.1-1' }} /s</div>
      </div>
    </div>
  </div>

  <div class="monitoring__consoles">
    <div class="monitoring__console" *ngFor="let t of ['GET', 'PUT', 'POST', 'DELETE']">
      <div class="monitoring__console-header">{{ t }} activity</div>
      <div class="monitoring__console-body">
        <div class="monitoring__console-line" *ngFor="let s of getConsoleFor(t)">
          <span class="monitoring__console-ts">{{ formatTimestamp(s) }}</span>
          <span class="monitoring__console-action">{{ s.event.action }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
